import { useMemo } from "react";
import { Helmet } from "react-helmet";

const PageHead = ({ userData }) => {
   
   const routeUrl = String(window.location.href);

   const { email, plan } = useMemo(() => ({
      plan: userData?.Intercom?.plan ?? "",
      email: userData?.Intercom?.email ?? "",
   }), [userData])

   return <>
      <Helmet>
         <title>{
            routeUrl.includes("/walls/home") ? ` Dashboard - Social Walls` : routeUrl.includes("/walls") ? `Walls - Social Walls` : routeUrl.includes("/transactions") ? `Transactions - Social Walls` : routeUrl.includes("/wall/index") ? ` Editor - Social Walls`
               : routeUrl.includes("/wall/moderation") ? `Moderation - Social Walls`
                  : routeUrl.includes("analytic") ? ` Analytics - Social Walls`
                     : routeUrl.includes("/profile") ? `Profile - Social Walls`
                        : routeUrl.includes("/notifications") ? `Notifications - Social Walls`
                           : routeUrl.includes("preview") ? `Walls - Social Walls` : `Social Walls ${routeUrl.includes("widget") ? "Widget" : "Display"}`

         }</title>
      </Helmet>

      {(!localStorage.getItem('Isadmin') && routeUrl.includes('app.') && email && !email?.includes('taggbox.com') && !email?.includes('tagshop.ai')) && <Helmet>
         <script type="text/javascript">{
            `window._mfq = window._mfq || [];
            (function() {
               var mf = document.createElement("script");
               mf.type = "text/javascript";
               mf.async = true;
               mf.src = "//cdn.mouseflow.com/projects/5d24672d-901f-43be-86a6-a92685f165a6.js";
               document.getElementsByTagName("head")[0].appendChild(mf);
            })();
            window._mfq.push(["setVariable", "UserName", "${email}"]);
            window._mfq.push(["setVariable", "PlanName", "${plan}"]);
            window._mfq.push(["setVariable", "useProduct", "Socialwalls"]);
            window._mfq.push(["setVariable", "UserType", "Cake"]);`
         }</script>
         <script>{
               `if(clarity){
                  window.clarity("set", "userEmail", "${email}");
                  window.clarity("set", "type", "app");
               }`}</script>
      </Helmet>
      }
   </>
}

export default PageHead

